import AnimatingDots from '~/components/AnimatingDots';
import Gap from '~/components/Gap';
import BasicSection from './BasicSection';
import CustomerSection from './CustomerSection';
import styles from './invoiceform.module.scss';
import InvoiceSettings from './InvoiceSettings';
import ItemSection from './ItemSection';
import NotesSection from './NotesSection';
import SummarySection from './SummarySection';
import { useInvoiceForm } from './useInvoiceForm';

const InvoiceForm = () => {
  const { formData, setValue, isLoading } = useInvoiceForm({});

  if (isLoading) {
    return (
      <div className="full-dimenstions center">
        <AnimatingDots />
      </div>
    );
  }

  return (
    <div className={`${styles.formContainer} full-width`}>
      <div className={styles.mainForm}>
        <BasicSection formData={formData} setValue={setValue} />
        <Gap t={40} />
        <CustomerSection formData={formData} setValue={setValue} />
        <Gap t={40} />
        <ItemSection formData={formData} setValue={setValue} />
        <SummarySection formData={formData} setValue={setValue} />
        <NotesSection formData={formData} setValue={setValue} />
      </div>

      <InvoiceSettings formData={formData} setValue={setValue} />
    </div>
  );
};

export default InvoiceForm;
